module.exports = __webpack_public_path__ + "img/struc-cip.dac8cd35.png";